import usePage, { IConfig } from './usePage'

const useConfig = (): IConfig => {
  const page = usePage()

  const { config } = page?.init_state?.global
  return config
}

export default useConfig
